import { render, staticRenderFns } from "./ManageDetailStatusOptions.vue?vue&type=template&id=ccb920be&scoped=true"
import script from "./ManageDetailStatusOptions.vue?vue&type=script&lang=js"
export * from "./ManageDetailStatusOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb920be",
  null
  
)

export default component.exports